import { useEffect } from "react";
import { useAuthStore } from "../store";

/** Bootstraps auth once at app mount. */
export function AuthInitializer({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    void useAuthStore.getState().initialize();
  }, []);

  return children;
}
